module.exports = __webpack_public_path__ + "img/logo.25bf8c19.png";